import Cookies from 'js-cookie'

const TokenKey = ' ASP.NET_SessionId'

export function getToken1() {
  return Cookies.get(TokenKey)
}

export function setToken1(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken1() {
  return Cookies.remove(TokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/token1.js